import * as Fathom from 'fathom-client'
import { stringToQueryParams } from './string'
import { AnalyticsBrowser, EventProperties, UserTraits } from '@segment/analytics-next'
import { isInBrowser } from './browser'
export const segmentAnalytics = new AnalyticsBrowser()

export const initSegmentAnalytics = () => {
  segmentAnalytics.load({ writeKey: process.env.GATSBY_SEGMENT_KEY })
}
const debugging = process.env.GATSBY_TRACK_SEGMENT_IN_DEV
const canTrackSegment =
  process.env.GATSBY_TRACK_SEGMENT_IN_DEV || process.env.NETLIFY_DEPLOY_CONTEXT == 'production'

export const trackSegmentEvent = (event: string, props: EventProperties) => {
  if (canTrackSegment) {
    if (debugging) {
      console.log('tracking segment event', event, props)
    }
    segmentAnalytics.track(event, props)
  } else {
    console.log('track Segment event', event, props)
  }
}

export const trackSegmentPage = () => {
  if (isInBrowser()) {
    if (canTrackSegment) {
      if (debugging) {
        console.log('tracking segment page')
      }
      segmentAnalytics.page('WCID')
    } else {
      console.log('track Segment page')
    }
  }
}

export const trackSegmentIdentity = (accountId: string, props: UserTraits) => {
  if (canTrackSegment) {
    if (debugging) {
      console.log('tracking segment identity', accountId, props)
    }
    segmentAnalytics.identify(accountId, props)
  } else {
    console.log('track Segment identity', accountId, props)
  }
}

export const trackPage = () => {
  if (process.env.NETLIFY_DEPLOY_CONTEXT == 'production') {
    Fathom.trackPageview()
  }
}
export const trackEvent = (name: string, opts?: Fathom.EventOptions) => {
  if (process.env.NETLIFY_DEPLOY_CONTEXT == 'production') {
    Fathom.trackEvent(name, opts)
  } else {
    console.log('track event', name)
  }
}
const splitOnCommaAndSortAlphabetically = (query: string) => {
  const splitOnComma = query.split(',')
  if (splitOnComma.length > 0) {
    return query
      .split(',')
      .sort((a, b) => a.localeCompare(b))
      .join(',')
  } else {
    return splitOnComma[0]
  }
}
export const trackSearchQuery = (paramString: string) => {
  const params = stringToQueryParams(paramString)
  const verbs = params.get('verbs')
  const nouns = params.get('nouns')
  const cobenefits = params.get('cobenefits')
  const endorsements = params.get('endorsements')
  const issues = params.get('issues')
  const verbsString = verbs && `verbs=${splitOnCommaAndSortAlphabetically(verbs)}`
  const nounsString = nouns && `verbs=${splitOnCommaAndSortAlphabetically(nouns)}`
  const cobenefitsString = cobenefits && `verbs=${splitOnCommaAndSortAlphabetically(cobenefits)}`
  const endorsementsString =
    endorsements && `verbs=${splitOnCommaAndSortAlphabetically(endorsements)}`
  const issuesString = issues && `verbs=${splitOnCommaAndSortAlphabetically(issues)}`
  const paramsString = [
    verbsString,
    nounsString,
    cobenefitsString,
    endorsementsString,
    issuesString
  ]
    .filter(exists => Boolean(exists))
    .join('&')

  trackEvent(paramsString)
}
